import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { useDispatch } from 'react-redux';
import editIcon from '../../images/icons/editIcon.svg';
import ApiPagination from '../common/ApiPagination';
import getAllPpeMaster from './queries/getAllPpeMaster';
import SearchBar from '../common/SearchBar';
import Header from '../common/Header';
import SubHeader from '../common/SubHeader';
import { resetVendorFilter } from '../../features/fliter/filterSliceVendor';
import { returnPolicies } from '../../PermissionUtility/ProfilePolicies';

const ItemsTable = ({ search }) => {
  const history = useHistory();
  const [pageNumber, setpageNumber] = useState(1);
  const [rowsCount, setrowsCount] = useState(10);
    const VesselGroupId = useParams();
    const columns = ['Rank', 'Gender', 'Price(INR)', 'Price(USD)', 'Action'];
    useEffect(() => {
      if (search?.length > 2) {
        setpageNumber(1);
      }
    }, [search]);
    const dataone = {
      Page: pageNumber,
      PageSize: rowsCount,
      searchCriteria: search?.length > 2 ? search : '',
      isAll: false,
      vesselGroupId: VesselGroupId?.ppeId
    };

  const { data: ppeList, isLoading: ppeMasterLoading } = getAllPpeMaster(dataone);
  const handleEdit = (itemId) => {
    history.push(`/ppe/${VesselGroupId?.ppeId}/${itemId}`);
  };
    return (
    <>
      <div className="items-table-rebuild-wrap">
        <table className="items-table-rebuild">
          <thead className="">
            <tr>
              {columns.map((item) => (
                <th key={item} className=" capitalize">{item}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ppeMasterLoading && (
              <tr className="">
                <td colSpan="4">Loading...</td>
              </tr>
            )}
            {ppeList?.data?.totalItems !== 0 ? (
              <>
                {ppeList?.data?.items?.map((item) => (
                  <tr key={item?.id} className="">
                    <td title={item?.rankName}>
                      <label>{item?.rankName}</label>
                    </td>
                    <td title={item?.gender}>
                      <label>{item?.gender}</label>
                    </td>
                    <td title={item?.totalPrice > 0 ? Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(item?.totalPrice) : null}>
                      <label>
                        {item?.totalPrice > 0 ? (
                          <>
                            {Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(item?.totalPrice)}
                          </>
                        )
                        : '-'}
                      </label>
                    </td>
                    <td title={item?.priceUsd > 0 ? Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(item?.priceUsd) : null}>
                      <label>
                        {item?.priceUsd > 0 ? (
                          <>
                            {Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(item?.priceUsd)}
                          </>
                        )
                        : '-'}
                      </label>
                    </td>
                    <td className="ppe-table-action">
                      <button onClick={() => handleEdit(item.id)} type="button">
                        <img src={editIcon} alt="EditIcon" title="Edit" className="action-icon w-6" />
                      </button>
                    </td>
                  </tr>
                ))}
              </>
            ) : (
              <tr className="">
                <td colSpan="4">No Data Found</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {ppeList?.data?.totalItems > 5 && (
        <ApiPagination
          currentPage={ppeList?.data?.currentPage}
          totalItems={ppeList?.data?.totalItems}
          pageSize={ppeList?.data?.pageSize}
          pageNumber={pageNumber}
          setpageNumber={setpageNumber}
          paginationRowList={[10, 20, 30, 40, 50]}
          rowsCount={rowsCount}
          handleRowsCount={setrowsCount}
          totalPages={ppeList?.data?.totalPages}
        />
      )}
    </>
    );
};

const ItemTableNav = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [search, setSearch] = useState('');
  const policies = returnPolicies();
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(resetVendorFilter());
  }, []);

  useEffect(() => {
    if (policies?.ppePolicies.canAccess === false) {
    history.push('/');
  }
}, [policies]);

  const tabChange = (tab) => {
    if (tab !== activeTab) {
      setActiveTab(tab);
      setSearch('');
    }
  };
  return (
    <>
    {policies?.ppePolicies.canAccess && (
      <div className="md:w-full">
        <Header headerName="PPE" parentPageLink="/ppe" parentPage="PPE" />
        <div className="manning-wrapper">
          <SubHeader
            searchComponent={<SearchBar handleSearch={(value) => setSearch(value)} search={search} placeholder="Search (Minimum 3 Characters)" />}
          />
          <div className="flex justify-between items-left full component-table-outline">
            <ul className="flex justify-between text-base text-gray-500 font-bold">
              <li
                className="cursor-pointer px-8 border-none rounded-t-xl text-center pt-1"
                style={{ backgroundColor: activeTab === 0 ? '#F8B113' : '#F1F1F1' }}
                onClick={() => tabChange(0)}
              >
                Item List
              </li>
            </ul>
          </div>
          {
           activeTab === 0
          && <ItemsTable search={search} />
          }
        </div>
      </div>
      )}
    </>
  );
};

export default ItemTableNav;
